
<template>
    <div class="OperateNavTable">
        <div v-for="(pack,unit) in [['特码','正码一','正码二','正码三','正码四'],['总和','','','','']]" class="l-flex o-mb">
            <template v-for="(item,index) in pack">
                <div v-if="index" style="padding:0 .2rem;" />
                <div class="l-flex-1">
                    <div v-if="item" class="row-title c-text-c">{{ item }}</div>
                    <group v-if="item" :client="client" :list="Table[unit * 5 + index + 1]" :length="1" />
                </div>
            </template>
        </div>
        <BoardFast :client="client" :group="TableAll" :step="true" />
    </div>
</template>

<script>
import CommonMix from '../common.js'
import Group from '../group.vue'
export default {
    name: 'OperateSyw8',
    mixins: [CommonMix],
    props: {
        client: {}
    },
    components: {
        Group
    }
}
</script>
